import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameMapCornerView} from './UIGameMapCornerView'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sound} from '../../Sound'
import {UICityWallHoverActionController} from '../ui_game_hover_actions/UICityWallHoverActionController'
import {MechanicCityWallState, TileCornerBonusType, TileCornerBuildingType} from '@colonist/game-states'
import {Point, TileCorner} from '@colonist/game-mechanic-validators'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import SoundType = Sound.SoundType
import {ArrayUtils} from '@colonist/utils'

export class UIGameMapCityWallController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly cityWallViews: UIGameMapCornerView[] = []

    constructor(uiGameManager: UIGameManager, cityWallState: MechanicCityWallState) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.cityWallViews = []
        if(!this.uiGameManager.gameController.isReplay) new UICityWallHoverActionController(this.uiGameManager, cityWallState)
        this.drawCityWalls(true)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.drawCityWalls(data as boolean == false); break
            default: break
        }
    }

    private drawCityWalls(drawExistingWalls: boolean) {
        this.checkAndRemoveCityWallsThatWereDestroyed()
        for(const corner of this.uiGameManager.gameState.mapState.tileState.tileCorners) {
            if(corner.buildingType != TileCornerBuildingType.City) continue
            if(!corner.hasCornerBonusOfType(TileCornerBonusType.CityWall)) continue
            if(this.cornerExists(corner)) continue
            this.drawCityWallOnCorner(corner, drawExistingWalls)
        }
    }

    private checkAndRemoveCityWallsThatWereDestroyed() {
        const cityWallViews = [...this.cityWallViews]
        for(const cityWallView of cityWallViews) {
            if(cityWallView.corner.hasCornerBonusOfType(TileCornerBonusType.CityWall)) continue

            cityWallView.parent.removeChild(cityWallView)
            ArrayUtils.removeElementFromArray(this.cityWallViews, cityWallView)
        }
    }

    private cornerExists(corner: TileCorner): boolean {
        for(const cityWallView of this.cityWallViews) {
            if(cityWallView.corner.sameCorner(corner)) return true
        }
        return false
    }

    private drawCityWallOnCorner(corner: TileCorner, drawExistingWall: boolean) {
        if(corner.owner == undefined) return

        const texture = UIGameSpriteHandler.getCityWallForPlayer(corner.owner)
        const mapView = this.uiGameManager.mapController.mapView
        const center = corner.hexCorner.toPixel(mapView.mapCenter, mapView.hexagonHeight / 2)
        const y = center.y - mapView.cornerCircleR * 0.6
        const x = center.x - mapView.cornerCircleR
        const w = mapView.cornerCircleR * 2
        const h = w
        const layer = mapView.layers.mapCityWall
        const animationStartY = drawExistingWall ? y : y - mapView.hexagonHeight
        const cityWallView = new UIGameMapCornerView(corner, x, animationStartY, w, h, layer, texture, mapView)

        const hexCorner = new Point(cityWallView.x, y)
        cityWallView.animationController.animationCompleteCallBack = () => {
            if(this.uiGameManager.gameController.isReplay) return
            if(drawExistingWall) return
            Sound.playSound(SoundType.CityWallPlace)
        }
        cityWallView.animationController.animateTo(hexCorner)
        this.cityWallViews.push(cityWallView)
        this.uiGameManager.mapController.mapView.sortChildren()
    }
}
